import { useStoreMap } from 'effector-react';
import type { ECategoryItem } from '@types';
import { $categoryMap } from '@stores/dataStores';
import cn from '@utils/cn';
import IconArrow from '@components/icons/IconArrow';
import { MoreMenu } from '../MoreMenu';

interface Props {
  id: number;
  isSub: boolean;
}

export function DraggingCategory({ id, isSub }: Props) {
  const { name } = useStoreMap({
    store: $categoryMap,
    keys: [id],
    fn: (state, [_id]) => state.get(_id) || ({} as ECategoryItem),
  });

  return (
    <div
      className={cn(
        'color-[#909090] flex h-40 w-[180px] items-center border pr-10 shadow-md',
        {
          'bg-[#f8f8f8] pl-45': isSub,
          'bg-white pl-10': !isSub,
        }
      )}
    >
      {!isSub && <IconArrow scheme="light" active className={cn('shrink-0')} />}
      <div title={name} className="grow truncate">
        {name}
      </div>
      <MoreMenu className="ml-auto" items={[] as const} onSelect={() => {}} />
    </div>
  );
}

export default DraggingCategory;
